import { render, staticRenderFns } from "./AssetItem.vue?vue&type=template&id=57bace74&"
import script from "./AssetItem.vue?vue&type=script&lang=js&"
export * from "./AssetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports